import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const Banner = styled.div`
  background-color: #282331;
  text-align: center;
  color: white;
  padding: 30px 20px 20px 20px;
  cursor: pointer;
`;

export const Header = styled.p`
  font-size: 1.3em;

  &::after {
    display: inline-block;
    content: '\f054';
    font-family: 'FontAwesome';
    margin-left: 15px;
    top: 2px;
    position: relative;
  }

  ${breakpoint('medium')`
    font-size: 1.3em;
  `}
`

export const LinkContainer = styled.div`
  text-align: center;
  margin: 0;
`

export const Link = styled.a`
  color: white;
  font-weight: bold;
  outline: none;

  &:hover {
    color: white;
  }
`